<template>
  <div class="product-detail">
    <a-tabs default-active-key="basicInfo">
      <a-tab-pane key="basicInfo" tab="基础信息">
        <a-card title="产品详情" style="width: 96%; margin: 2% auto">
          <template #extra>
            <a-select
              v-model="languageSelect"
              allow-clear
              placeholder="请选择翻译语言"
              show-search
              option-filter-prop="children"
              :style="{ width: '8vw' }"
              @change="handleLanguage"
            >
              <a-select-option v-for="(language, key) in languageOptions" :key="key" :value="language.value">
                {{
                  language.label
                }}
              </a-select-option>
            </a-select>
          </template>
          <a-descriptions title="产品基础数据" bordered>
            <a-descriptions-item label="产品ID">
              {{ form.productId }}
            </a-descriptions-item>
            <a-descriptions-item label="产品名称">
              {{ form.name }}
            </a-descriptions-item>
            <a-descriptions-item label="产品类型">
              <a-select v-model="form.type" :disabled="true">
                <a-select-option :value="$constRepository.product.PRODUCT_TYPE_OPTIONS.root">
                  父设备
                </a-select-option>
                <a-select-option :value="$constRepository.product.PRODUCT_TYPE_OPTIONS.child">
                  子设备
                </a-select-option>
                <a-select-option :value="$constRepository.product.PRODUCT_TYPE_OPTIONS.thirdParty">
                  第三方设备
                </a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item label="中控内部驱动标识符">
              {{ form.driver || '-' }}
            </a-descriptions-item>
            <a-descriptions-item label="产品能力">
              {{
                showCapabilitiesText(form.capabilities) || '-'
              }}
            </a-descriptions-item>
            <a-descriptions-item label="产品控制协议类型">
              <a-select v-model="form.protocol" :disabled="true">
                <a-select-option v-for="(filter, key) in metaData.productProtocols" :key="key" :value="filter.value">
                  {{
                    filter.name
                  }}
                </a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item label="产品图标">
              <div class="clearfix">
                <a-upload list-type="picture-card" accept="image/*" :file-list="iconImage" @preview="handlePreview" />
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                  <img alt="example" style="width: 100%" :src="previewImage">
                </a-modal>
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="用户是否可见">
              <a-switch
                v-model="form.userVisible"
                :disabled="true"
                checked-children="是"
                un-checked-children="否"
                default-checked
              />
            </a-descriptions-item>
            <a-descriptions-item label="强电设备">
              <a-switch
                v-model="form.metadata.strongCurrent"
                :disabled="true"
                checked-children="是"
                un-checked-children="否"
                default-checked
              />
            </a-descriptions-item>

            <a-descriptions-item label="产品使用频率">
              <template v-if="form.useFrequency">
                {{
                  $constRepository.product.USE_FREQUENCY_OPTIONS.find((option) => option.value === form.useFrequency)
                    .label
                }}
              </template>
            </a-descriptions-item>
            <a-descriptions-item label="发布区域">
              {{ form.regions ? form.regions.map((region) => region.name).join('、') : '-' }}
            </a-descriptions-item>
            <a-descriptions-item label="可连接子设备数量">
              {{ form.childrenCount }}
            </a-descriptions-item>
            <a-descriptions-item label="子节点产品id">
              {{ form.children.length ? form.children.join('、') : '-' }}
            </a-descriptions-item>
            <a-descriptions-item label="可选子节点产品id">
              {{ form.optionChildren && form.optionChildren.length ? form.optionChildren.join('、') : '-' }}
            </a-descriptions-item>
            <a-descriptions-item label="子设备数量限制">
              {{ form.childrenCountLimit || '-' }}
            </a-descriptions-item>
            <a-descriptions-item label="备注">
              {{ form.remark || '-' }}
            </a-descriptions-item>
          </a-descriptions>
          <template v-if="form.internalModels && form.internalModels.length > 0">
            <div class="loadDevice_title">
              关联产品型号
            </div>
            <a-table :data-source="form.internalModels" size="middle" row-key="id">
              <a-table-column key="identifier" title="产品型号" align="center" data-index="identifier" />
              <a-table-column key="name" title="产品名称" align="center" data-index="name" />
            </a-table>
          </template>
          <template v-if="form.loadedDeviceTypes && form.loadedDeviceTypes.length > 0">
            <div class="loadDevice_title">
              产品负载设备类型
            </div>
            <a-descriptions
              v-for="loadedDeviceType in form.loadedDeviceTypes"
              :key="loadedDeviceType.loadedDeviceTypeId"
              class="loadDevice_description"
              :column="2"
              bordered
            >
              <a-descriptions-item label="负载设备类型ID">
                {{ loadedDeviceType.loadedDeviceTypeId }}
              </a-descriptions-item>
              <a-descriptions-item label="负载设备类型名称">
                {{ loadedDeviceType.name }}
              </a-descriptions-item>
              <a-descriptions-item label="负载设备类型类别">
                <span v-if="loadedDeviceType.categories">
                  {{
                    loadedDeviceType.categories
                      .map((category) => $constRepository.loadedDevice.CategoriesLabel[category])
                      .join('、')
                  }}
                </span>
                <span v-else> - </span>
              </a-descriptions-item>
            </a-descriptions>
          </template>
          <template v-if="form.properties && form.properties.length > 0">
            <div class="loadDevice_title">
              产品属性
            </div>
            <LoadedDevicePropertyCard :properties="form.properties" />
          </template>
          <template v-if="form.services && form.services.length > 0">
            <div class="loadDevice_title">
              产品服务
            </div>
            <a-descriptions
              v-for="service in form.services"
              :key="service.identifier"
              class="product_service"
              :column="2"
              bordered
            >
              <a-descriptions-item label="服务标识符">
                {{ service.identifier }}
              </a-descriptions-item>
              <a-descriptions-item label="服务描述">
                {{ service.description.defaultMessage }}
              </a-descriptions-item>
              <a-descriptions-item label="超时值">
                {{ service.timeout }}
              </a-descriptions-item>
              <a-descriptions-item label="备注">
                {{ service.remark }}
              </a-descriptions-item>
            </a-descriptions>
          </template>
          <template v-if="form.configurationItems && form.configurationItems.length > 0">
            <div class="loadDevice_title">
              产品配置
            </div>
            <a-descriptions
              v-for="configurationItem in form.configurationItems"
              :key="configurationItem.id"
              class="product_configuration"
              :column="2"
              bordered
            >
              <a-descriptions-item label="配置标识符">
                {{ configurationItem.identifier }}
              </a-descriptions-item>
              <a-descriptions-item label="配置描述">
                {{ configurationItem.description.defaultMessage }}
              </a-descriptions-item>
              <a-descriptions-item label="配置类型">
                <span>{{
                  metaData.dataPrimitiveTypes.find((type) => type.value == configurationItem.type.type).name
                }}</span>
              </a-descriptions-item>
              <a-descriptions-item label="编辑方式">
                <span>{{ $constRepository.productFormItem.editModeText[configurationItem.type.editMode] }}</span>
              </a-descriptions-item>
              <a-descriptions-item label="默认值">
                <span>{{ configurationItem.type.defaultValue || '无' }}</span>
              </a-descriptions-item>
              <template v-if="configurationItem.type.editMode == $constRepository.productFormItem.editMode.input">
                <a-descriptions-item label="范围">
                  <span v-if="configurationItem.type.type !== $constRepository.product.DATA_PRIMITIVE_TYPES.BOOL">
                    {{ `${configurationItem.type.range.min}-${configurationItem.type.range.max}` }}
                  </span>
                  <span v-else>无</span>
                </a-descriptions-item>
              </template>
              <template v-if="configurationItem.type.editMode == $constRepository.productFormItem.editMode.select">
                <a-descriptions-item label="选项">
                  <p v-for="(option, index) in configurationItem.type.options" :key="index">
                    {{ `${option.value}:${option.description.defaultMessage}` }}
                  </p>
                </a-descriptions-item>
              </template>
            </a-descriptions>
          </template>
        </a-card>
      </a-tab-pane>
      <a-tab-pane key="codeEdit" tab="代码编辑器">
        <a-card title="编辑器" style="width: 96%; margin: 0 auto; margin-bottom: 2%">
          <VueJsonEditor v-model="form" :show-btns="false" mode="code" lang="zh" style="height: 800px" />
        </a-card>
      </a-tab-pane>
    </a-tabs>

    <div style="width: 96%; margin: 0 auto; margin-bottom: 2%">
      <a-button type="primary" style="margin-top: 2%" @click="$router.back()">
        返回
      </a-button>
    </div>
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor'
import LoadedDevicePropertyCard from '../loaded-device/components/loadedDevicePropertyCard'

export default {
  name: 'ProductDetail',
  components: {
    VueJsonEditor: vueJsonEditor,
    LoadedDevicePropertyCard,
  },
  data() {
    return {
      languageSelect: this.$constRepository.language.FILTER_OPTION_ZH_CN.value,
      languageOptions: this.$constRepository.language.FILTER_OPTIONS,
      form: {
        metadata: {},
        regions: [],
        children: [],
      },
      previewVisible: false,
      previewImage: '',
      iconImage: [],
      metaData: this.$store.state.metaData,
    }
  },
  async mounted() {
    if (this.$route.params.id)
      await this.listProductById(this.$route.params.id)
  },
  methods: {
    async handlePreview(file) {
      const imageFile = file
      if (!imageFile.url && !imageFile.preview)
        imageFile.preview = await this.getBase64(imageFile.originFileObj)

      this.previewImage = imageFile.url || imageFile.preview
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },
    async listProductById(id) {
      const headers = {
        'accept-language': this.languageSelect,
        'FULL-PRODUCT': true,
      }
      const response = await this.$apiManager.product.getProductById(id, headers)
      Object.assign(this.form, response.data)
      this.initImages()
    },
    initImages() {
      if (this.form.iconDownloadUrl) {
        this.iconImage = [
          {
            url: this.form.iconDownloadUrl,
            filePath: this.form.icon,
            name: this.form.icon,
            uid: -1,
          },
        ]
      }
    },
    async handleLanguage() {
      await this.listProductById(this.$route.params.id)
    },
    showCapabilitiesText(capabilities = []) {
      if (capabilities && capabilities.length > 0) {
        return capabilities
          .map(capability => this.$constRepository.product.ALL_PRODUCT_CAPABILITY[capability] || '')
          .join(',')
      }
      return ''
    },
    cancel() {
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.jsoneditor-poweredBy {
  display: none;
}
// /deep/.jsoneditor-outer {
//   height: 25vw;
// }
/deep/ .jsoneditor-vue {
  height: 100%;
}
.green-btn {
  color: green;
  border: none;
}
.loadDevice_title {
  margin-top: 4%;
  margin-bottom: 20px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
  font-size: 16px;
  line-height: 1.5;
}
.product_configuration {
  margin-top: 1%;
}

.product_service {
  margin-top: 1%;
}
.loadDevice_description {
  margin-top: 1%;
}
.product-detail {
  /deep/ .ant-descriptions-row {
    width: 100%;
    word-break: break-all;
    .ant-descriptions-item-label {
      width: 170px;
    }
    .ant-descriptions-item-content {
      width: 200px;
    }
  }
}
</style>
